import moment from 'moment';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';

export const useUtil = () => {
  const dispatch = useAppDispatch();
  const showError = (message: string) => {
    dispatch(setMessage({ msgDetails: message, severity: 'error' }));
  };
  const showSuccess = (message: string, stayOpen = false) => {
    dispatch(setMessage({ msgDetails: message, severity: 'success' }));
  };

  const handleError = (errorData: any, show404 = false) => {
    if (errorData?.status === 403) {
      showError(`${errorData?.status}: Forbbiden Access`);
    } else if (errorData?.status === 404 && show404) {
      showError(`${errorData?.data?.context?.message}`);
    } else if (errorData?.status === 401) {
      showError(`${errorData?.data?.detail} , Refresh the screen`);
    } else if (errorData?.status === 400) {
      showError(`${errorData?.status}: Bad Request`);
    } else if (errorData?.status === 405) {
      showError(`${errorData?.status}: Method Not Allowed`);
    } else if (
      errorData?.status === 500 ||
      errorData?.status === 502 ||
      errorData?.status === 503 ||
      errorData?.status === 504
    ) {
      showError(errorData?.data?.context?.message ?? `${errorData?.status}: Internal Server Error `);
    } else if (errorData?.status === 422) {
      const massage = errorData?.data?.context?.message ? `${errorData?.data?.context?.message}` : `Invalid Data`;
      showError(`${errorData?.status}: ${massage}`);
    } else if (errorData?.status === 409) {
      showError(`${errorData?.data?.context?.message || errorData?.data?.detail || 'Error Data'}`);
    } else if (errorData?.status != 404) {
      showError(`Internal Server Error`);
    }
  };
  const openModal = () => {
    window.parent.postMessage({ action: 'MODAL_OPEN' }, getPoratlHost());
  };

  const closeModal = () => {
    window.parent.postMessage({ action: 'MODAL_CLOSE' }, getPoratlHost());
  };
  const dataDetailsCreation = (staticData: any, ApiData: any, requredData: any = null, DateFormat = 'MM-DD-YYYY') => {
    return staticData.map((ele: any) => {
      if (ele.type === 'date') {
        return {
          ...ele,
          value: ApiData[ele.apiKey]
            ? moment(ApiData[ele.apiKey]).format(DateFormat.toUpperCase())
            : ApiData[ele.apiKey]
        };
      } else if (ele.type === 'array') {
        return {
          ...ele,
          value: ApiData[ele.apiKey]?.replaceAll(',', ', ')
        };
      } else if (ele.split) {
        return {
          ...ele,
          value: ApiData[ele.apiKey]?.replaceAll(ele.split_with, ', ')
        };
      } else if (ele.updateData) {
        return {
          ...ele,
          value: ele.updateData?.[ApiData[ele.apiKey]]
        };
      } else if (ele.dependent && requredData) {
        return {
          ...ele,
          value: requredData[ele?.dependent_Arr]?.map((data: any) => data?.[ele?.dependent_field])?.toString()
        };
      } else {
        return {
          ...ele,
          value: ApiData[ele.apiKey]
        };
      }
    });
  };

  return {
    openModal,
    closeModal,
    handleError,
    showSuccess,
    showError,
    dataDetailsCreation
  };
};

export const getPoratlHost = () => {
  const portalURL = document.referrer;
  if (portalURL) {
    const url = new URL(portalURL);
    return url.origin;
  } else {
    return document.location.href;
  }
};
